import { render, staticRenderFns } from "./medalList.vue?vue&type=template&id=387b702a&scoped=true"
import script from "./medalList.vue?vue&type=script&lang=js"
export * from "./medalList.vue?vue&type=script&lang=js"
import style0 from "./medalList.vue?vue&type=style&index=0&id=387b702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b702a",
  null
  
)

export default component.exports